<template>
    <div class="companies h-100 d-flex align-items-center">

        <div class="w-100" v-if="this.account.accessType && this.account.accessType == 1" @click="toggle" v-click-outside="close">
            <div class="pointer d-flex align-items-center">
                <strong class="supplierName">{{ brand }}</strong>
                <span :class="['ml-auto', 'dark', 'ico-arrow-' + icon]" v-if="accessPermissionFilter(['admin'])"></span>
            </div>

            <div class="settings fs-small lighter bg-lighter shadowed" v-if="isVisible && accessPermissionFilter(['admin'])">
                <div class="edit bg-lightest py-4 dark d-flex align-items-center">
                    <router-link class="dark" :to="{ name: 'settings'}">
                        <strong>Company settings</strong>
                        <u class="ico-settings larger"></u>
                    </router-link>
                </div>
            </div>
        </div>

        <div v-else>
            <div class="d-flex align-items-center">
                <strong>{{ brand }}</strong>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data: function() {
            return {
                isVisible: false,
                icon: 'bottom'
            }
        },
        computed: {
            ...mapGetters([
                'account',
            ]),
            brand: function() {
                let brand = '-';

                if (this.account.supplier && this.account.supplier.brand !== undefined) {
                    brand = this.account.supplier.brand;
                }
                else if (this.account.agent && this.account.agent.brand !== undefined) {
                    brand = this.account.agent.brand;
                }

                return brand;
            },
        },
        methods: {
            toggle: function(e) {
                this.isVisible = !this.isVisible;
                this.icon = (this.icon == 'top') ? 'bottom' : 'top';
            },
            close: function(e) {
                this.icon = 'bottom';
                this.isVisible = false;
            }
        }
    }
</script>

<style media="screen" scoped>
    .supplierName{
        line-height: 1rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
</style>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .bar {
        .companies {
            flex: 0 0 33.33333%;
            max-width: 33.33333%;
            min-width: 230px;
            padding: 0 1.25rem;
            border-right: 2px solid $light;
            position: relative;

            .settings {
                line-height: 1rem;
                position: absolute;
                width: 100%;
                top: 100%;
                left: 0;
                z-index: 5;

                > .edit {
                    padding: 0 1.25rem 1rem 1.25rem;
                }

                > ul > li {
                    padding: 0.5rem 0;

                    &.selected {
                        color: $dark;
                    }
                }
            }

            &.open {
                .settings {
                    display: block;
                }
            }
        }

        @media (min-width: 960px) {
            .companies {
                flex: 0 0 25%;
                max-width: 25%;
                padding: 0 1.25rem;
            }
        }

        @media (min-width: 1200px) {
            .companies {
                flex: 0 0 20%;
                max-width: 20%;
                padding: 0 1.25rem;
            }
        }

        @media (min-width: 1380px) {
            .companies {
                flex: 0 0 17%;
                max-width: 17%;
                padding: 0 1.25rem;
            }
        }

        @media (min-width: 1650px) {
            .companies {
                flex: 0 0 14.5%;
                max-width: 14.5%;
                padding: 0 1.25rem;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Companies.vue?63bbe0cd